export default {
	id: 'SIMPLE_PAYWALL_4W_29_99_24W_12_00',
	providers: {
		paltaMap: {
			USD: 'simple_premium_comm_4w_29_99_24w_12_usd',
			EUR: 'simple_premium_comm_4w_29_99_24w_12_eur',
			GBP: 'simple_premium_comm_4w_29_99_24w_12_gbp',
			CAD: 'simple_premium_comm_4w_49_99_24w_20_cad',
			AUD: 'simple_premium_comm_4w_49_99_24w_20_aud',
			DKK: 'simple_premium_comm_4w_259_24w_104_dkk',
			SEK: 'simple_premium_comm_4w_399_24w_159_sek',
			NOK: 'simple_premium_comm_4w_399_24w_159_nok',
			BRL: 'simple_premium_comm_4w_199_90_24w_79_90_brl',
			MXN: 'simple_premium_comm_4w_499_24w_199_mxn',
			TRY: 'simple_premium_comm_4w_999_24w_399_try',
			ARS: 'simple_premium_comm_4w_39990_24w_16000_ars',
			COP: 'simple_premium_comm_4w_119990_24w_49000_cop',
			CLP: 'simple_premium_comm_4w_29990_24w_12000_clp',
		},
		primer: 'prd_12ovSF4Cws8m',
	},
	model: {
		commitment_period: 6,
		intro_period_value: 4,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 12,
			EUR: 12,
			GBP: 12,
			CAD: 20,
			AUD: 20,
			DKK: 104,
			SEK: 159,
			NOK: 159,
			BRL: 79.9,
			MXN: 199,
			TRY: 399,
			ARS: 16000,
			COP: 49000,
			CLP: 12000,
		},
		originalPriceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			CAD: 49.99,
			AUD: 49.99,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 199.9,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			CAD: 49.99,
			AUD: 49.99,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 199.9,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
}
